import FindFolderRequest from 'owa-service/lib/contract/FindFolderRequest';
import FindFolderResponseMessage from 'owa-service/lib/contract/FindFolderResponseMessage';
import findFolderOperation from 'owa-service/lib/operation/findFolderOperation';
import findFolderRequest from 'owa-service/lib/factory/findFolderRequest';
import folderResponseShape from 'owa-service/lib/factory/folderResponseShape';
import propertyUri from 'owa-service/lib/factory/propertyUri';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
import BaseFolderId from 'owa-service/lib/contract/BaseFolderId';
import FolderId from 'owa-service/lib/contract/FolderId';
import getDefaultRequestOptions from './getDefaultRequestOptions';
import indexedPageView from 'owa-service/lib/factory/indexedPageView';
import { MailboxType } from 'owa-client-ids';

const MAX_ENTRIES_RETURNED = 1000; // Same as server limit when indexedPageView not passed

export function configureRequestBody(
    baseFolderIds: BaseFolderId[],
    indexedPageOffset: number
): FindFolderRequest {
    return findFolderRequest({
        FolderShape: folderResponseShape({
            BaseShape: 'IdOnly',
            AdditionalProperties: [
                propertyUri({ FieldURI: 'DistinguishedFolderId' }),
                propertyUri({ FieldURI: 'FolderClass' }),
                propertyUri({ FieldURI: 'FolderDisplayName' }),
                propertyUri({ FieldURI: 'ParentFolderId' }),
                propertyUri({ FieldURI: 'TotalCount' }),
                propertyUri({ FieldURI: 'UnreadCount' }),
            ],
        }),
        Paging: indexedPageView({
            BasePoint: 'Beginning',
            Offset: indexedPageOffset,
            MaxEntriesReturned: MAX_ENTRIES_RETURNED,
        }),
        ParentFolderIds: baseFolderIds,
        ReturnParentFolder: true,
        ShapeName: 'Folder',
        Traversal: 'Deep',
    });
}

/**
 *
 * @param baseFolderId base folder id for which we want to fetch the folder hierarchy
 * @param indexedPageOffset the offset from which to fetch
 * @param userIdentity the user identifier (smtp) that has permission to fetch/view these folders
 * @param mailboxType the mailbox type, currently we only fetch folders for UserMailbox types
 */
export default function findFolders(
    baseFolderId: BaseFolderId,
    indexedPageOffset: number = 0,
    userIdentity?: string,
    mailboxType: MailboxType = MailboxType.UserMailbox // Currently this findfolders is used only in UserMailbox scenarios.
): Promise<FindFolderResponseMessage> {
    const folderId = baseFolderId as FolderId;
    let requestBody = configureRequestBody([folderId], indexedPageOffset);
    const requestOptions = getDefaultRequestOptions(folderId.Id, null, userIdentity, mailboxType);
    return findFolderOperation(
        {
            Header: getJsonRequestHeader(),
            Body: requestBody,
        },
        requestOptions
    ).then(response => {
        return response.Body.ResponseMessages.Items[0] as FindFolderResponseMessage;
    });
}
